export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.30-1024.57",
  commitId: "1e60ba5e55668fed27702cc4dcae16dfe8a745be",
  commitTime: "2026-09-30T10:24:57.000Z",
});
